module.exports = __webpack_public_path__ + "static/media/level2.092791dc.svg";